<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="edi_source_keyno" [ttModel]="edit.edi_source_keyno" ttReadonly></tt-input>
        <tt-select ttLabel="edi_source_type" [(ttModel)]="edit.edi_source_type" [ttData]="selectListExternalTypes" ttDataId="edi_source_type" ttDataName="edi_source_type_name"></tt-select>
        <tt-input ttLabel="edi_source_name" [(ttModel)]="edit.edi_source_name" ttRequired></tt-input>

        <div [hidden]="edit.edi_source_type !== 'ftp'">
            <tt-select ttLabel="ftpaccount" [(ttModel)]="edit.ftpaccount_keyno" [ttData]="selectListFtpAccounts" ttDataId="item_id" ttDataName="item_name"></tt-select>
            <tt-input ttLabel="ftp_remotefolder" [(ttModel)]="edit.ftp_remotefolder"></tt-input>
            <tt-input ttLabel="ftp_localfolder" [(ttModel)]="edit.ftp_localfolder"></tt-input>
        </div>

        <tt-input [hidden]="edit.edi_source_type !== 'folder'" ttLabel="folder_localfolder" [(ttModel)]="edit.folder_localfolder"></tt-input>
        <tt-input [hidden]="edit.edi_source_type !== 'ws'" ttLabel="ws_endpoint" [(ttModel)]="edit.ws_endpoint"></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="edisource_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
